<app-tech-services-tabs [offers]="serviceOfferings"
                        [contractId]="contractId"
                        [userEmail]="userEmail"
                        [userType]="userType"
                        [usersOnContract]="usersOnContract"></app-tech-services-tabs>
